import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import DocFullScreenExample from '../UI/DocFullScreenExample';
import HeaderExample from '../examples/Header';
const HeaderExampleSource = require('!!raw-loader!../examples/Header');
const HeaderPage = () => (<div>
        <Helmet title="Header"/>
        <h3>Header</h3>
        <DocFullScreenExample>
            <HeaderExample />
        </DocFullScreenExample>
        <pre>
            <PrismCode className="language-jsx">{HeaderExampleSource}</PrismCode>
        </pre>
    </div>);
export default HeaderPage;
